export default __webpack_public_path__ + "static/media/land_light.5f0b241e.png";